module.exports = __webpack_public_path__ + "img/unfavourite.02983381.png";